module.exports = __webpack_public_path__ + "img/electronic_no_zone.da8afb43.svg";